import { MutationTree } from 'vuex';
import { IState, IItem } from './state';
import { ActionPayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
	state.initialNumberToShow = payload.numberToShow;
}

const setItemsMutation: MutationHandler<IItem[]> = (state, { payload }) => {
	state.items = payload
}

const setNumberToShowMutation: MutationHandler<number> = (state, { payload }) => {
	state.numberToShow = payload
}

const setLoadingMutation: MutationHandler<boolean> = (state, { payload }) => {
	state.loading = payload
}

const setSelectedTagsMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedTags = payload
}

const setQueryMutation: MutationHandler<string> = (state, { payload }) => {
	state.query = payload
}

const setTotalMutation: MutationHandler<number> = (state, { payload }) => {
	state.total = payload;
}

const setSortMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedSort = payload
}

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setLoading: setLoadingMutation,
	setItems: setItemsMutation,
	setNumberToShow: setNumberToShowMutation,
	setSelectedTags: setSelectedTagsMutation,
	setQuery: setQueryMutation,
	setTotal: setTotalMutation,
	setSort: setSortMutation,
}


export default mutations
